import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enJSON from './locale/en.json'
import esJSON from './locale/es.json'
import ptJSON from './locale/pt.json'
import arJSON from './locale/ar.json'

i18n.use(initReactI18next).init({
    resources: {
        es: { translation: {...esJSON} },
        en: { translation: {...enJSON} },
        pt: { translation: {...ptJSON} },
        ar: { translation: {...arJSON} },
    },
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
})

export default i18n;
